module.exports = __webpack_public_path__ + "static/media/top-nfts-8.e3e17697.jpg";